// Traduction à la volée via l'API gratuite MyMemory (même mécanisme que le projet food-truck)
// Les textes sont découpés en petits lots pour éviter les URLs trop longues (rejetées par l'API/CORS).
const MAX_CHUNK_CHARS = 400
const SEP = '\n'

function chunkTexts(texts) {
  const chunks = []
  let current = []
  let currentLen = 0
  for (const text of texts) {
    const len = text.length + SEP.length
    if (current.length && currentLen + len > MAX_CHUNK_CHARS) {
      chunks.push(current)
      current = []
      currentLen = 0
    }
    current.push(text)
    currentLen += len
  }
  if (current.length) chunks.push(current)
  return chunks
}

async function translateChunk(chunk, from, to) {
  try {
    const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(chunk.join(SEP))}&langpair=${from}|${to}`
    const data = await fetch(url).then(r => r.json())
    if (data.responseStatus !== 200) return chunk.map(() => null)
    const parts = data.responseData.translatedText.split(SEP)
    return chunk.map((orig, i) => parts[i]?.trim() || null)
  } catch {
    return chunk.map(() => null)
  }
}

export async function translateBatch(texts, from, to) {
  if (!texts.some(t => t)) return null
  const safe = texts.map(t => (t || '').replace(/\n/g, ' '))
  const chunks = chunkTexts(safe)
  try {
    const results = await Promise.all(chunks.map(chunk => translateChunk(chunk, from, to)))
    const flat = results.flat()
    return safe.map((_, i) => flat[i] || texts[i])
  } catch {
    return null
  }
}

export async function translateOne(text, from, to) {
  if (!text) return null
  try {
    const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=${from}|${to}`
    const data = await fetch(url).then(r => r.json())
    if (data.responseStatus !== 200) return null
    return data.responseData.translatedText
  } catch {
    return null
  }
}
